module.exports = __webpack_public_path__ + "assets/img/success-icon.02a5f56b.png";